<ew-mat-dialog-custom>
  <ew-mat-stepper-custom
    [validations]="validations"
    [sendIn]="'penultimate'"
    [textForSendButton]="'shared:send'"
    (send)="onStepperNext()"
    #stepper>
    <ew-mat-stepper-custom-step>
      <div class="grid gap-4 max-w-2xl m-auto">
        <div class="flex flex-wrap">
          <h1 class="w-full text-4xl font-bold">
            {{ 'commissions:currencyAccountTitle' | translate }}
          </h1>
          <h2 class="mb-5 font-medium text-gray-500">
            {{ 'commissions:currencyAccountSubtitle' | translate }}
          </h2>
        </div>

        <div class="flex flex-col justify-center">
          <form class="grid gap-2" [formGroup]="payment">
            <div class="flex items-center gap-4">
              <mat-form-field class="flex-1">
                <mat-label class="font-semibold">
                  {{ 'commissions:currencyAccounts' | translate }}
                  <small class="text-gray-400">
                    ({{ 'shared:required' | translate }})
                  </small>
                </mat-label>

                <mat-select
                  [class.h-16]="payment.get('currencyAccount')?.value !== null"
                  formControlName="currencyAccount"
                  required="true"
                  [disabled]="loadingCurrencies">
                  <mat-select-trigger
                    *ngIf="payment?.get('currencyAccount')?.value !== null">
                    <div class="flex items-center">
                      <img
                        class="object-cover w-10 h-10 rounded-full mr-4"
                        src="https://flagcdn.com/{{
                          payment.get('currencyAccount')?.value.currencyIso
                            | currencyCountry
                        }}.svg"
                        [alt]="
                          'Currency flag for ' +
                          payment.get('currencyAccount')?.value.currencyIso
                        "
                        loading="lazy" />

                      <div class="flex flex-col">
                        <span>
                          {{
                            payment.get('currencyAccount')?.value.currencyIso
                          }}
                        </span>
                        <span class="text-gray-400">
                          {{ 'studentPaymentV2:currentBalance' | translate }}
                          {{
                            payment.get('currencyAccount')?.value.balance
                              | currency
                          }}
                        </span>
                      </div>
                    </div>
                  </mat-select-trigger>

                  <mat-option
                    [value]="item"
                    *ngFor="let item of currencyAccounts">
                    <div class="flex items-center">
                      <img
                        class="object-cover w-6 h-6 rounded-full mr-2"
                        src="https://flagcdn.com/{{
                          item.currencyIso | currencyCountry
                        }}.svg"
                        width="36"
                        height="27"
                        [alt]="'Currency flag for ' + item.currencyIso"
                        loading="lazy" />
                      {{ item.currencyIso }}
                    </div>
                  </mat-option>
                </mat-select>

                <mat-error *ngIf="payment.controls['currencyAccount'].errors">
                  <strong> {{ 'shared:isRequired' | translate }}</strong>
                </mat-error>
              </mat-form-field>

              <div *ngIf="loadingCurrencies" class="flex items-center">
                <mat-progress-spinner diameter="24" mode="indeterminate">
                </mat-progress-spinner>
              </div>
            </div>

            <div class="flex-col">
              <label class="text-sm font-semibold" for="amount">
                {{ 'commissions:amountToReceive' | translate }}
              </label>

              <div class="flex items-center">
                <span class="font-bold text-5xl mr-4 mt-1">
                  {{
                    getCurrencySymbol(
                      payment.get('currencyAccount')?.value?.currencyIso
                    )
                  }}
                </span>
                <input
                  ewPreventScroll
                  matInput
                  class="font-bold text-5xl mr-4 mt-1"
                  mask="separator.2"
                  thousandSeparator=","
                  decimalMarker="."
                  name="amount"
                  formControlName="amount"
                  placeholder=".01"
                  step="0.01"
                  min="0.01"
                  max="5000000"
                  required />
              </div>
              <div class="flex">
                <span class="text-sm text-gray-400">
                  {{ 'commissions:futureBalance' | translate }}
                </span>
                <span
                  class="inline-flex items-center text-sm font-bold ml-2"
                  *ngIf="payment.get('amount')?.value !== null">
                  {{ futureBalance | currency }}
                </span>
              </div>
            </div>

            <div class="mt-2">
              <mat-label class="font-semibold mb-2">
                <h2 class="text-sm">
                  {{ 'commissions:invoiceNumber' | translate }}
                </h2>
              </mat-label>
              <input
                class="block w-full p-2 border rounded-md {{
                  payment.get('invoiceNumber')?.errors &&
                  payment.get('invoiceNumber')?.value !== ''
                    ? 'border-red-500'
                    : 'border-gray-300'
                }}"
                matInput
                formControlName="invoiceNumber"
                name="invoiceNumber" />
              <mat-error
                *ngIf="
                  payment.controls['invoiceNumber'].errors &&
                  (payment.controls['invoiceNumber'].dirty ||
                    payment.controls['invoiceNumber'].touched)
                ">
                <span
                  *ngIf="payment.controls['invoiceNumber'].errors['required']"
                  class="text-xs text-red-500 font-semibold"
                  >{{ 'shared:isRequired' | translate }}</span
                >

                <span
                  *ngIf="payment.controls['invoiceNumber'].errors['minlength']"
                  class="text-xs text-red-500 font-semibold"
                  >{{
                    payment.controls['invoiceNumber'].errors['minlength']
                      | errorMinValue
                  }}</span
                >

                <span
                  *ngIf="payment.controls['invoiceNumber'].errors['maxlength']"
                  class="text-xs text-red-500 font-semibold">
                  {{
                    payment.controls['invoiceNumber'].errors['maxlength']
                      | errorMaxValue
                  }}
                </span>
              </mat-error>
              <p class="text-gray-500 text-xs">
                {{
                  'invoiceFunds:confirmationInvoiceNumberDescription'
                    | translate
                }}
              </p>
            </div>

            <div class="mt-2">
              <mat-label class="font-semibold mb-2">
                <h2 class="text-sm">
                  {{ 'commissions:confirmationProviderName' | translate }}
                </h2>
              </mat-label>
              <input
                class="block w-full p-2 border rounded-md {{
                  payment.controls['providerName'].errors &&
                  payment.controls['providerName'].value !== ''
                    ? 'border-red-500'
                    : 'border-gray-300'
                }}"
                matInput
                step="3"
                formControlName="providerName"
                id="provider-name" />
              <mat-error
                *ngIf="
                  payment.controls['providerName'].errors &&
                  (payment.controls['providerName'].dirty ||
                    payment.controls['providerName'].touched)
                ">
                <span
                  *ngIf="payment.controls['providerName'].errors['required']"
                  class="text-xs text-red-500 font-semibold"
                  >{{ 'shared:isRequired' | translate }}</span
                >

                <span
                  *ngIf="payment.controls['providerName'].errors['minlength']"
                  class="text-xs text-red-500 font-semibold"
                  >{{
                    payment.controls['providerName'].errors['minlength']
                      | errorMinValue
                  }}</span
                >

                <span
                  *ngIf="payment.controls['providerName'].errors['maxlength']"
                  class="text-xs text-red-500 font-semibold">
                  {{
                    payment.controls['providerName'].errors['maxlength']
                      | errorMaxValue
                  }}
                </span>
              </mat-error>
              <p class="text-gray-500 text-xs pt-1">
                {{
                  'commissions:confirmationProviderNameDescription' | translate
                }}
              </p>
            </div>
          </form>
        </div>
      </div>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step>
      <div class="grid gap-4 max-w-2xl mx-auto px-4">
        <div class="flex flex-wrap">
          <h1 class="w-full text-4xl font-bold">
            {{ 'commissions:companyInformationTitle' | translate }}
          </h1>
          <h2 class="mb-5 font-medium text-gray-500">
            {{ 'commissions:companyInformationSubtitle' | translate }}
          </h2>
        </div>

        <div class="flex flex-col justify-center">
          <form [formGroup]="profile">
            <mat-radio-group
              formControlName="externalProfile"
              class="flex flex-col gap-4">
              <mat-radio-button
                *ngFor="let option of options"
                [value]="option.value"
                [disabled]="option.disabled"
                class="flex items-center h-20 px-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                <div class="ml-3 flex flex-col justify-center">
                  <span class="text-sm font-medium text-gray-900">{{
                    option.title | translate
                  }}</span>
                  <span class="text-xs text-gray-500 mt-1">{{
                    option.subtitle | translate
                  }}</span>
                </div>
              </mat-radio-button>
            </mat-radio-group>
          </form>

          <!-- Internal Profile Form -->
          <div *ngIf="showInternalProfileStep" class="mt-8">
            <form [formGroup]="corporateProfile" class="space-y-4">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
                <!-- Profile Name -->
                <mat-form-field class="w-full mb-2">
                  <mat-label class="font-semibold"
                    >{{ 'commissions:profileName' | translate }}
                    <small class="text-gray-400">
                      {{ 'shared:required' | translate }}
                    </small>
                  </mat-label>
                  <input
                    matInput
                    required
                    formControlName="profileName"
                    placeholder="{{
                      'commissions:profileNamePlaceholder' | translate
                    }}" />
                  <mat-error
                    *ngIf="
                      corporateProfile.get('profileName')?.hasError('required')
                    ">
                    {{ 'commissions:profileNameRequired' | translate }}
                  </mat-error>
                  <mat-error
                    *ngIf="
                      corporateProfile.get('profileName')?.hasError('minlength')
                    ">
                    {{ 'commissions:profileNameMinLength' | translate }}
                  </mat-error>
                </mat-form-field>

                <!-- Country -->
                <ew-select-country
                  [width]="'100%'"
                  [value]="corporateProfile.value.country"
                  (valueChanged)="
                    corporateProfile.patchValue({
                      country: $event.iso,
                    });
                    onCountryChange()
                  "
                  [label]="'commissions:country'"
                  [isAvailableToReceiveCommissionPayments]="true">
                </ew-select-country>

                <!-- Province (Optional) -->
                <ng-container *ngIf="showInputProvince">
                  <mat-form-field>
                    <mat-label class="font-semibold mb-2">
                      {{ 'invoiceFunds:provinceInput' | translate }}
                      <small class="text-gray-400">
                        ({{ 'shared:required' | translate }})
                      </small>
                    </mat-label>
                    <mat-select formControlName="province">
                      <mat-option
                        [value]="item.provinceId"
                        *ngFor="let item of provinces">
                        {{ item.name }}</mat-option
                      >
                    </mat-select>
                    <mat-error
                      *ngIf="corporateProfile.controls['province'].errors">
                      <span
                        *ngIf="
                          corporateProfile.controls['province'].errors[
                            'required'
                          ]
                        ">
                        {{ 'commissions:province' | translate }}
                        <strong> {{ 'shared:isRequired' | translate }}</strong>
                      </span>
                    </mat-error>
                  </mat-form-field>
                </ng-container>

                <!-- City -->
                <mat-form-field class="w-full">
                  <mat-label>{{ 'commissions:city' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="city"
                    placeholder="{{
                      'commissions:cityPlaceholder' | translate
                    }}" />
                  <mat-error *ngIf="corporateProfile.controls['city'].errors">
                    {{ 'commissions:cityRequired' | translate }}
                  </mat-error>
                </mat-form-field>

                <!-- Postal Code -->
                <mat-form-field class="w-full">
                  <mat-label>{{
                    'commissions:postalCode' | translate
                  }}</mat-label>
                  <input
                    matInput
                    formControlName="postalCode"
                    placeholder="{{
                      'commissions:postalCodePlaceholder' | translate
                    }}" />
                  <mat-error
                    *ngIf="corporateProfile.controls['postalCode'].errors">
                    <span
                      *ngIf="
                        corporateProfile.controls['postalCode'].errors[
                          'required'
                        ]
                      ">
                      {{ 'commissions:postalCodeRequired' | translate }}
                    </span>

                    <span
                      *ngIf="
                        corporateProfile.controls['postalCode'].errors[
                          'minlength'
                        ]
                      "
                      class="text-xs text-red-500 font-semibold">
                      {{
                        corporateProfile.controls['postalCode'].errors[
                          'minlength'
                        ] | errorMinValue
                      }}
                    </span>

                    <span
                      *ngIf="
                        corporateProfile.controls['postalCode'].errors[
                          'maxlength'
                        ]
                      "
                      class="text-xs text-red-500 font-semibold">
                      {{
                        corporateProfile.controls['postalCode'].errors[
                          'maxlength'
                        ] | errorMaxValue
                      }}
                    </span>
                  </mat-error>
                </mat-form-field>

                <!-- Phone Number -->
                <mat-form-field class="w-full">
                  <mat-label>{{
                    'commissions:phoneNumber' | translate
                  }}</mat-label>
                  <input
                    matInput
                    formControlName="phoneNumber"
                    placeholder="{{
                      'commissions:phoneNumberPlaceholder' | translate
                    }}" />
                  <mat-error
                    *ngIf="corporateProfile.controls['phoneNumber'].errors">
                    <span
                      *ngIf="
                        corporateProfile.controls['phoneNumber'].errors[
                          'required'
                        ]
                      ">
                      {{ 'commissions:phoneNumberRequired' | translate }}
                    </span>

                    <span
                      *ngIf="
                        corporateProfile.controls['phoneNumber'].errors[
                          'minlength'
                        ]
                      "
                      class="text-xs text-red-500 font-semibold">
                      {{
                        corporateProfile.controls['phoneNumber'].errors[
                          'minlength'
                        ] | errorMinValue
                      }}
                    </span>

                    <span
                      *ngIf="
                        corporateProfile.controls['phoneNumber'].errors[
                          'maxlength'
                        ]
                      "
                      class="text-xs text-red-500 font-semibold">
                      {{
                        corporateProfile.controls['phoneNumber'].errors[
                          'maxlength'
                        ] | errorMaxValue
                      }}
                    </span>
                  </mat-error>
                </mat-form-field>

                <!-- Company Address -->
                <mat-form-field class="w-full">
                  <mat-label>{{
                    'commissions:companyAddress' | translate
                  }}</mat-label>
                  <input
                    matInput
                    formControlName="address"
                    placeholder="{{
                      'commissions:companyAddressPlaceholder' | translate
                    }}" />
                  <mat-error
                    *ngIf="corporateProfile.controls['address'].errors">
                    {{ 'commissions:companyAddressRequired' | translate }}
                  </mat-error>
                </mat-form-field>

                <!-- Tax ID (Optional) -->
                <ng-container
                  *ngIf="corporateProfile.controls['country'].value === 'br'">
                  <mat-form-field>
                    <mat-label class="font-semibold mb-2">
                      {{ 'invoiceFunds:taxIdInput' | translate }}
                      <small class="text-gray-400">
                        ({{ 'shared:required' | translate }})
                      </small>
                    </mat-label>
                    <input
                      matInput
                      placeholder="XX.XXX.XXX/0001-XX"
                      mask="00.000.000/0000-00"
                      [dropSpecialCharacters]="true"
                      required
                      formControlName="taxId" />
                  </mat-form-field>
                </ng-container>
                <ng-container
                  *ngIf="corporateProfile.controls['country'].value === 'co'">
                  <mat-form-field>
                    <mat-label class="font-semibold mb-2">
                      NIT (Tax ID)
                      <small class="text-gray-400">
                        ({{ 'shared:required' | translate }})
                      </small>
                    </mat-label>
                    <input
                      matInput
                      placeholder="XXX.XXX.XXX-X"
                      mask="000.000.00-0||000.000.000-0"
                      [dropSpecialCharacters]="true"
                      required
                      formControlName="taxId" />
                    <mat-error
                      *ngIf="
                        corporateProfile.controls['taxId'].errors?.['required']
                      ">
                      {{ 'invoiceFunds:taxIdInput' | translate
                      }}<strong> {{ 'shared:isRequired' | translate }}</strong>
                    </mat-error>
                    <mat-error
                      *ngIf="
                        corporateProfile.controls['taxId'].errors?.[
                          'invalidNIT'
                        ]
                      ">
                      {{ 'shared:invalid' | translate }} NIT
                    </mat-error>
                  </mat-form-field>
                </ng-container>
                <ng-container
                  *ngIf="corporateProfile.controls['country'].value === 'cl'">
                  <mat-form-field>
                    <mat-label class="font-semibold mb-2">
                      RUT (Tax ID)
                      <small class="text-gray-400">
                        ({{ 'shared:required' | translate }})
                      </small>
                    </mat-label>
                    <input
                      matInput
                      placeholder="XX.XXX.XXX-X"
                      mask="00.000.000-A"
                      [dropSpecialCharacters]="true"
                      required
                      formControlName="taxId" />
                    <mat-error
                      *ngIf="
                        corporateProfile.controls['taxId'].errors?.['required']
                      ">
                      {{ 'invoiceFunds:taxIdInput' | translate
                      }}<strong> {{ 'shared:isRequired' | translate }}</strong>
                    </mat-error>
                    <mat-error
                      *ngIf="
                        corporateProfile.controls['taxId'].errors?.[
                          'invalidRUT'
                        ]
                      ">
                      {{ 'shared:invalid' | translate }} RUT
                    </mat-error>
                  </mat-form-field>
                </ng-container>
              </div>
            </form>
          </div>
        </div>
      </div>
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step>
      <div class="flex justify-center">
        <mat-progress-spinner
          *ngIf="loadingCreateCommissions"
          [diameter]="40"
          [mode]="'indeterminate'"></mat-progress-spinner>
      </div>
      <ng-container *ngIf="!loadingCreateCommissions && commission">
        <h1>
          {{ 'commissions:orderOverviewCommission' | translate }} #C{{
            commission.id
          }}
        </h1>

        <table class="w-3/4 mt-5">
          <tbody class="text-lg">
            <tr>
              <td>{{ 'commissions:columnAmountToSend' | translate }}:</td>
              <td class="font-bold">
                {{ commission.amountToSend | currency }}
                {{ payment.get('currencyAccount')?.value?.currencyIso }}
              </td>
            </tr>
            <tr>
              <td>{{ 'commissions:invoiceNumber' | translate }}:</td>
              <td class="font-bold">
                {{ commission.invoiceNumber }}
              </td>
            </tr>
            <tr>
              <td>
                {{ 'commissions:orderOverviewProviderName' | translate }}
              </td>
              <td class="font-bold">
                {{ commission.providerName }}
              </td>
            </tr>

            <tr>
              <td>
                {{ 'commissions:commissionProfile' | translate }}
              </td>
              <td class="font-bold text-gray-500">
                {{ 'commissions:providerWillAddProfile' | translate }}
              </td>
            </tr>
          </tbody>
        </table>

        <div class="mt-10 flex">
          <div class="flex items-center ml-4 mr-6">
            <i class="fa-solid fa-circle-bolt text-green-500 text-5xl"></i>
          </div>
          <div>
            <div>
              <span class="text-lg font-bold">{{
                'commissions:linkReady' | translate
              }}</span>
            </div>
            <div>{{ 'commissions:linkReadySubtitle' | translate }}</div>
          </div>
        </div>

        <div class="flex mt-5">
          <div
            class="bg-gray-100 rounded-lg p-4 text-sm text-gray-600 break-all"
            matTooltip="{{ tooltipMessage | translate }}"
            [matTooltipPosition]="'above'"
            #tooltipUrl="matTooltip"
            (click)="
              copyToClipboard(
                publicLink || commission.commissionRequestUrl,
                tooltipUrl
              )
            ">
            {{ publicLink || commission.commissionRequestUrl }}
          </div>
          <div
            class="flex items-center ml-4 p-5 cursor-pointer"
            matTooltip="{{ tooltipMessage | translate }}"
            [matTooltipPosition]="'above'"
            #tooltipCopy="matTooltip"
            (click)="
              copyToClipboard(
                publicLink || commission.commissionRequestUrl,
                tooltipCopy
              )
            ">
            <i class="fa-regular fa-copy text-2xl"></i>
          </div>
          <div
            class="flex items-center p-5 cursor-pointer"
            (click)="
              openPaymentLink(publicLink || commission.commissionRequestUrl)
            ">
            <i class="fa-regular fa-external-link text-2xl"></i>
          </div>
        </div>

        <div class="mt-10 flex gap-4">
          <button
            mat-stroked-button
            color="primary"
            class="rounded-full"
            (click)="matDialogService.commissions()">
            <i class="fa-regular fa-plus mr-2"></i>
            {{ 'commissions:createAnotherCommissionRequest' | translate }}
          </button>
          <button
            mat-stroked-button
            class="rounded-full"
            color="primary"
            (click)="redirectToPaymentDetails()">
            <mat-icon class="mr-2">open_in_new</mat-icon>
            {{ 'commissions:viewCommissionPaymentDetails' | translate }}
          </button>
        </div>
      </ng-container>
    </ew-mat-stepper-custom-step>
  </ew-mat-stepper-custom>
</ew-mat-dialog-custom>
